<template>
  <div class='phone-body'>
    <div v-if='step === 1'
      class='feed'
      v-dragscroll.y>
      <vuegram-post v-for='post in posts'
        :post='post'
        :key='posts.indexOf(post)'>
      </vuegram-post>
      <div class="container is-fluid" v-if='posts.length=== 0'>
      <div class="notification is-danger">
      Momentálne nemáme žiadne príspevky v tejto kategórii.
    </div>
    </div>
    </div>
    <div v-if='step === 2'>
      <div class='selected-image'
        :class='selectedFilter'
        :style="{ backgroundImage: 'url(' + image + ')' }">
      </div>
      <div class='filter-container' v-dragscroll.x>
        <filter-type v-for='filter in filters'
          :filter='filter'
          :image='image'
          :key='filters.indexOf(filter)'>
        </filter-type>
      </div>
    </div>
    <div v-if='step === 3'>
      <div class='selected-image-3'
        :class='selectedFilter'
        :style="{ backgroundImage: 'url(' + image + ')' }">
      </div>
      <div class='field'>
        <div class="control">
        <textarea
          class='caption-input'
          type='text'
          rows=1
          :value='username'
          placeholder='Vložte meno'
          @input="$emit('update:username', $event.target.value)">
        </textarea>
        </div>
      </div>
      <div class='field'>
        <div class="control">
        <textarea class='caption-input'
        placeholder='Vložte komentár k fotke ...'
          type='text'
          rows=3
          :value='caption'
          @input="$emit('update:caption', $event.target.value)">
        </textarea>
        </div>
      </div>
      <div class='field'>
        <div class="control">
          <div class="select is-fullwidth">
        <select class='caption-input'
        :value='category'
        @input="$emit('update:category', $event.target.value)">
        <option> -- vyberte kategóriu</option>
        <option value="ludia">Ľudia</option>
        <option value="priroda">Príroda</option>
        <option value="kultura">Kultúra</option>
        <option value="sport">Šport</option>
        <option value="zabava">Zábava</option>
        </select>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VuegramPost from './VuegramPost';
import FilterType from './FilterType';

export default {
  name: 'PhoneBody',
  props: {
    step: Number,
    posts: Array,
    filters: Array,
    image: String,
    selectedFilter: String,
    username: String,
    caption: String,
  },
  methods: {    
  },
  mounted() {    
  },
  components: {
    'vuegram-post': VuegramPost,
    'filter-type': FilterType,
  },
};
</script>

<style lang='scss' src='../styles/phone-body.scss'>
// Styles from stylesheet
</style>



// WEBPACK FOOTER //
// src/components/PhoneBody.vue